import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withProps, branch, renderNothing, lifecycle, withHandlers } from 'recompose';

import namespaces from './namespaces';
import { getMaintenanceMessage, isMaintenanceDismissed } from '../../auth/selectors';
import { dismissMaintenanceMessage } from '../../auth/actions';

export default compose(
  withRouter,
  connect(state => ({
    message: getMaintenanceMessage(state),
    isDismissed: isMaintenanceDismissed(state),
  }), {
    dismissMaintenanceMessage,
  }),
  withProps((props) => {
    const isPathnameEnabled = namespaces.some(ns => (new RegExp(ns)).test(props.location.pathname));
    return {
      children: isPathnameEnabled && !props.isDismissed && props.message,
    };
  }),
  withHandlers({
    onDismiss: props => () => {
      props.dismissMaintenanceMessage();
    },
  }),
  branch(
    props => !props.children,
    renderNothing,
  ),
  lifecycle({
    componentDidMount() {
      const maintenanceBarHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--maintenance-bar-expanded-height');

      document.documentElement.style.setProperty('--maintenance-bar-height', maintenanceBarHeight);
    },
    componentWillUnmount() {
      document.documentElement.style.setProperty('--maintenance-bar-height', '0px');
    },
  }),
);
